import React, { useEffect } from 'react'
import Auth from './login/login';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard/dashboard';
import FormBuilder from './form-builder/form-builder';
import FormSubmit from './form-submit/form-submit';
import { SnackbarProvider } from './contexts/SnackbarContext';
import { UserProvider } from './contexts/UserContext';

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={(
            <SnackbarProvider>
              <UserProvider>
                <Auth />
              </UserProvider>
            </SnackbarProvider>
          )} />
          <Route path="/dashboard" element={(
            <SnackbarProvider>
              <UserProvider>
                <Dashboard />
              </UserProvider>
            </SnackbarProvider>
          )}></Route>
          <Route path="/forms/builder" element={(
            <SnackbarProvider>
              <UserProvider>
                <FormBuilder />
              </UserProvider>
            </SnackbarProvider>
          )}></Route>
          <Route path="/forms/:shareId" element={(
            <SnackbarProvider>
              <FormSubmit />
            </SnackbarProvider>
          )} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default App